import PropTypes from "prop-types";

import SoftTypography from "components/SoftTypography";

/** Contor discret, afișat doar când utilizatorul se apropie de limita câmpului. */
function CharacterCounter({ value = "", limit }) {
  if (value.length < limit * 0.9) return null;

  return (
    <SoftTypography
      variant="caption"
      color={value.length >= limit ? "error" : "text"}
      sx={{ display: "block", mt: 0.5, textAlign: "right" }}
    >
      {value.length}/{limit}
    </SoftTypography>
  );
}

CharacterCounter.propTypes = {
  value: PropTypes.string,
  limit: PropTypes.number.isRequired,
};

export default CharacterCounter;
